import { useMemo } from 'react';

import { createApiClient } from '../../api/client';
import { useAuthToken } from '../../hooks/useAuthToken';

export function useApiClient() {
  const { token } = useAuthToken();

  return useMemo(() => createApiClient(token), [token]);
}
